import styled from 'styled-components';

export const ApiKeyColumnWrap = styled.div`
  display: flex;
  align-items: center;
  max-width: 100%;
`;
export const ApiKeyRoute = styled.div`
  display: flex;
  align-items: center;
  column-gap: 15px;
  flex-wrap: wrap;
`;
export const ApiKeyRouteLabel = styled.h3`
  min-width: 85px;
`;
export const ApiKeyRouteField = styled.div`
  display: flex;
  align-items: center;
  column-gap: 15px;
  .af-superadmin-api-settings-api-route-wrap-input {
    height: 35px;
    min-width: 200px;
  }
  &.af-superadmin-api-settings-api-route-wrap-button {
    column-gap: 0px;
  }
`;

export const ApiKeyTextWrap = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  overflow-x: auto;
  white-space: nowrap;
`;

export const ApiKeyText = styled.div`
  user-select: none;
  display: inline-block;
  overflow: hidden;
  width: 100%;
`;
